module.exports = __webpack_public_path__ + "static/img/1.aae735a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/1.jpg
// module id = wEJg
// module chunks = 1